module.exports = __webpack_public_path__ + "img/video.f78b0bba.svg";